import { Box, Switch, TableBody, TableCell, TableRow, TextField } from '@mui/material';
import { FC } from 'react';
import TimeHelper from '../../../utils/time';
import Helper from '../../../utils/helper';
import { CPP, cppCls } from '../cargoPrioritization.classes';
interface IProps {
    datas?: any;
    handleChangePriorty?: any;
    handleChangeOrderLimit?: any;
    handleSwitchChangeRedirectIsActive?: any;
    handleSwitchChangeCodRedirectIsActive?: any;
}
export const CargoPrioritizationBody: FC<IProps> = ({
    datas,
    handleChangePriorty,
    handleChangeOrderLimit,
    handleSwitchChangeRedirectIsActive,
    handleSwitchChangeCodRedirectIsActive,
}) => {
    return (
        <TableBody className={CPP.tableBody}>
            {datas.shippingCompanyRedirects?.map((data: any, index: any) => {
                const matchingData = datas.priorityOrders.find(
                    (item: any) => item.shippingCompanyId === data.shippingCompanyId
                );
                return (
                    <TableRow key={index}>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                }}
                            >
                                {/* <p style={{ justifyContent: 'center', display: 'flex', textAlign: 'center' }}>{data.priority}</p> */}
                                <TextField
                                    type="number"
                                    value={data.priority?.toString().replace(/^0+(?=\d)/, '')}
                                    onChange={(event: any) => handleChangePriorty(event, index, datas)}
                                    className={cppCls(CPP.input, CPP.inputTextfield, CPP.fieldRowPriority)}
                                    slotProps={{
                                        htmlInput: {
                                            style: { textAlign: 'center' },
                                        },
                                    }}
                                    style={{
                                        justifyContent: 'center',
                                        display: 'flex',
                                        textAlign: 'center',
                                        maxHeight: '5rem',
                                        maxWidth: '14rem',
                                    }}
                                />
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                }}
                            >
                                <b style={{ justifyContent: 'center', display: 'flex' }}>{data?.shippingCompanyName}</b>
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    display: 'flex',
                                }}
                            >
                                <Switch
                                    checked={data.redirectIsActive}
                                    className={cppCls(CPP.input, CPP.inputSwitch, CPP.fieldRedirectActive)}
                                    onClick={(event: any) => handleSwitchChangeRedirectIsActive(event, index, datas)}
                                />
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    display: 'flex',
                                }}
                            >
                                <Switch
                                    checked={data.codRedirectIsActive}
                                    disabled={data.codSupported ? false : true}
                                    className={cppCls(CPP.input, CPP.inputSwitch, CPP.fieldCodRedirectActive)}
                                    onClick={(event: any) => handleSwitchChangeCodRedirectIsActive(event, index, datas)}
                                />
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                }}
                            >
                                {/* <p style={{ justifyContent: 'center', display: 'flex' }}>{data.orderLimits}</p> */}
                                <TextField
                                    type="number"
                                    value={Helper.formatNumberWithDots(data.orderLimits)}
                                    onChange={(event: any) => handleChangeOrderLimit(event, index, datas)}
                                    className={cppCls(CPP.input, CPP.inputTextfield, CPP.fieldRowOrderLimit)}
                                    slotProps={{
                                        htmlInput: {
                                            style: { textAlign: 'center' },
                                        },
                                    }}
                                    style={{
                                        justifyContent: 'center',
                                        display: 'flex',
                                        textAlign: 'center',
                                        maxHeight: '5rem',
                                        maxWidth: '14rem',
                                    }}
                                />
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <p style={{ justifyContent: 'center', display: 'flex' }}>
                                    {matchingData ? matchingData.orderQuantity : ' - '}
                                </p>
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <p style={{ justifyContent: 'center', display: 'flex' }}>
                                    {matchingData ? matchingData.priortyOrderQuantity : ' - '}
                                </p>
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <p style={{ justifyContent: 'center', display: 'flex', fontSize: '1.4rem' }}>
                                    {TimeHelper.formatDateHour(data.changeOn)}
                                </p>
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box
                                className={CPP.cellBox}
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    minHeight: '5rem',
                                    minWidth: '14rem',
                                    backgroundColor: 'white',
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <p style={{ justifyContent: 'center', display: 'flex' }}>{data.userName}</p>
                            </Box>
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    );
};
